import { translate } from 'vue-gettext'

const { pgettext } = translate

// Table field definitions for edge orders
export const edgeOrdersFields = {
  transactionNumber: {
    key: 'transaction_number',
    label: pgettext('edge-prints.fields', 'Transaction Number'),
    _style: 'width: 12%',
    sortable: true,
    requiresPermission: ['edge.print.transaction_number']
  },
  createdAt: {
    key: 'created_at',
    label: pgettext('edge-prints.fields', 'Created'),
    _style: 'width: 13%',
    sortable: true,
    requiresPermission: ['edge.print.created_at']
  },
  cabin: {
    key: 'cabin',
    label: pgettext('edge-prints.fields', 'Cabin'),
    _style: 'width: 10%',
    requiresPermission: ['edge.print.cabin']
  },
  guest: {
    key: 'guest',
    label: pgettext('edge-prints.fields', 'Guest'),
    _style: 'width: 10%',
    requiresPermission: ['edge.print.guest']
  },
  picacode: {
    key: 'picacode',
    label: pgettext('edge-prints.fields', 'PicaCode'),
    _style: 'width: 10%',
    requiresPermission: ['edge.print.picacode']
  },
  status: {
    key: 'status',
    label: pgettext('edge-prints.fields', 'Status'),
    _style: 'width: 12%',
    sortable: true,
    requiresPermission: ['edge.print.status']
  },
  paymentPlatform: {
    key: 'payment_platform',
    label: pgettext('edge-prints.fields', 'Payment Platform'),
    _style: 'width: 12%',
    requiresPermission: ['edge.print.payment_platform']
  },
  totalAmount: {
    key: 'total_amount',
    label: pgettext('edge-prints.fields', 'Total'),
    _style: 'width: 12%',
    sortable: true,
    filter: false,
    requiresPermission: ['edge.print.total']
  },
  actions: {
    key: 'actions',
    label: '',
    _style: 'width: 10%',
    sorter: false,
    filter: false
  }
}

// Re-export from shared constant files
export * from '@/domain/core/constant/printJobStatus'